/** 首页 Open 模块编码：热搜词 */
export const HOMEPAGE_OPEN_MODULE_HOT_SEARCH = '10300';

/** 首页 Open 模块编码：推荐文字链 */
export const HOMEPAGE_OPEN_MODULE_RECOMMEND_TEXT_LINK = '10400';

/** NavBar 热搜词 + 推荐文字链按需加载模块列表 */
export const HOMEPAGE_NAV_OPEN_MODULE_CODES = [
  HOMEPAGE_OPEN_MODULE_HOT_SEARCH,
  HOMEPAGE_OPEN_MODULE_RECOMMEND_TEXT_LINK,
] as const;
